import React from "react";
import CustomTable from "../../components/CustomTable";
import { getStates } from "../../../services/CommonServices";
import { stateValidationSchema } from "../../../utils/validationSchemas/MasterDataSchema";
import AddUpdateState from "./AddUpdate";

const State = () => {
  const columns = [
    {
      label: "#",
      render: (row, index, currentPage, pageSize) => (
        <span>{(currentPage - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      label: "Country",
      render: (row, index) => <span>{row.country.name}</span>,
    },
    {
      label: "Name",
      key: "name",
    },
    {
      label: "Code",
      key: "code",
    },
  ];
  const modalConfig = {
    initialValues: {
      country: "",
      name: "",
      code: "",
    },
    validationSchema: stateValidationSchema,
    apiUrl: "master/states",
    FormComponent: AddUpdateState,
    addTitle: "Add State",
    updateTitle: "Update State",
    extraProps: {
      relationKeys: ["country"],
    },
  };
  return (
    <CustomTable
      formModal={true}
      title="States"
      addBtnTitle="Add New State"
      columns={columns}
      getHook={getStates}
      store={"state"}
      deleteHook={"master/states"}
      modalConfig={modalConfig}
      search={true}
    />
  );
};

export default State;
